import React from 'react';

import arrayMove from 'array-move';
import { RightCircleOutlined, MenuOutlined, DownCircleOutlined } from '@ant-design/icons';
import { Row, Col, Table } from 'antd';
import { compose } from '../../core';
import styled from 'styled-components';
import {
  getIntFromString,
  EditIcon,
  DeleteIcon
} from '../../look';
import { sortableContainer, sortableElement, sortableHandle } from 'react-sortable-hoc';
import { withEditQuestion, withEditChoice, withDeleteQuestion } from './SurveyOperations';
import ChoiceTable from './ChoiceTable';
import ROUTE from '../route';
import ReactMarkdown from '../../look/components/ReactMarkdown';
import '../css/survey-admin-panel.css';


const QuestionTable = props => {
  const { record, deleteQuestion, editQuestion, setSequenceLoading, questionSetLoading } = props;
  const { questionSet } = record;
  const SortableItem = sortableElement(props => <tr {...props} />);
  const SortableContainer = sortableContainer(props => <tbody {...props} />);
  const [dataSource, setDataSource] = React.useState([]);
  // eslint-disable-next-line no-unused-vars
  const [allowDraggable, setAllowDraggable] = React.useState(true);
  React.useEffect(() => {
    const edges = [];
    questionSet &&
      questionSet.edges.length > 0 &&
      // eslint-disable-next-line array-callback-return
      questionSet.edges.map(({ node }, index) => {
        edges.push({ ...node, index: index + 1 });
      });
    setDataSource(edges);

  }, [questionSet]);
  const handleDelete = async id => {
    setSequenceLoading(true);
    try {
      await deleteQuestion({ id: id })
    } catch (e) {
      throw new Error(e.message);
    }
    setSequenceLoading(false);
  };
  const onSort = async sortedItems => {
    try {
      await Promise.all(
        sortedItems.map(async i => {
          // const response = await
          editQuestion({ id: getIntFromString(i.id), sequence: i.index + 1 });
        })
      );
    } catch (e) {
      throw Error(e.message);
    }
  };
  const onSortEnd = ({ oldIndex, newIndex }) => {
    if (oldIndex !== newIndex) {
      const newData = arrayMove([].concat(dataSource), oldIndex, newIndex).filter(el => !!el);
      const indexData = [];
      // eslint-disable-next-line array-callback-return
      newData.map((node, index) => {
        const data = newData[index];
        indexData.push({ ...data, index: index });
      });
      onSort && onSort(indexData);
      setDataSource(indexData);
    }
  };
  const DragHandle = sortableHandle(() => (
    <MenuOutlined style={{ 
      cursor: 'grab', 
      color: '#999', 
      fontSize: 18,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '10%',
      width: '100%'
    }} />
  ));
  const DraggableContainer = props => (
    <SortableContainer useDragHandle disableAutoscroll helperClass="row-dragging" onSortEnd={onSortEnd} {...props} />
  );
  const DraggableBodyRow = ({ className, style, ...restProps }) => {
    const index = dataSource && dataSource.findIndex(x => x.index === restProps['data-row-key']);
    return <SortableItem style={{ border: "1px solid #f5f5f5", borderRadius: '5px', width: "100%" }} index={index} {...restProps} />;
  };
  const columns = [
    {
      title: 'Sort',
      dataIndex: 'sort',
      width: '6%',
      className: 'drag-visible sort-column',
      render: () => <DragHandle />
    },
    {
      title: 'Name',
      key: 'name',
      // className: 'drag-visible',
      render: (text, record) => record &&
        <ReactMarkdown style={{ margin: '0' }} className="question-table-row-text-container">{record.questionText}</ReactMarkdown>
    },
    {
      title: 'help',
      key: 'help',
      render: (text, record) => record && <>
        <ReactMarkdown style={{ margin: '0.5em 0' }}>{record.helpText}</ReactMarkdown></>
    },
    {
      title: 'Link',
      key: 'link',
      align: 'right',
      width: 120,
      render: (text, record) => (
        <Row gutter={[24, 24]} justify="end" align='middle'>
          <Col style={{padding:'0 16px'}}>
            <EditIcon
              type="link"
              size="md"
              tooltipSuffix="Question"
              href={`${ROUTE.editQuestionLink}${getIntFromString(record.id)}`} />
          </Col>
          <Col>
            <DeleteIcon
              size="md"
              tooltipSuffix="Question"
              onClick={() => handleDelete(getIntFromString(record.id))} />
          </Col>
        </Row>
      )
    }
  ];
  // const dragable = allowDraggable
  //   ? {
  //       components: {
  //         body: {
  //           wrapper: DraggableContainer,
  //           row: DraggableBodyRow
  //         }
  //       }
  //     }
  //   : {};

  return (
    <MyTable
      className="expand question-table-custom"
      showHeader={false}
      tableLayout={'auto'}
      rowKey={'index'}
      loading={questionSetLoading}
      expandable={{
        expandedRowRender: (record, index, indent, expanded) => (
          <ChoiceTable record={record} index={index} indent={indent} expanded={expanded} />
        ),
        expandIcon: ({ expanded, onExpand, record }) =>
          record.choiceSet.edgeCount !== 0 ? (
            expanded ? (
              <DownCircleOutlined
                onClick={e => {
                  setAllowDraggable(true);
                  onExpand(record, e);
                }}
                style={{ 
                  fontSize: 18, 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  height: '24px',
                  width: '100%',
                  color: '#CACACA' 
                }}
              />
            ) : (
              <RightCircleOutlined
                onClick={e => {
                  setAllowDraggable(false);
                  onExpand(record, e);
                }}
                style={{ 
                  fontSize: 18, 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  height: '24px',
                  width: '100%',
                  color: '#CACACA' 
                }}
              />
            )
          ) : null
      }}
      pagination={false}
      columns={columns}
      dataSource={
        dataSource &&
        dataSource.length > 0 &&
        dataSource.sort((a, b) => (a.sequence < b.sequence ? -1 : a.sequence > b.sequence ? 1 : 0))
      }
      components={{
        body: {
          wrapper: DraggableContainer,
          row: DraggableBodyRow
        }
      }}
    />
  );
};
export default compose(withEditQuestion, withDeleteQuestion, withEditChoice)(QuestionTable);

const MyTable = styled(Table)`
  &.question-table-custom {
    .sort-column {
      width: 6% !important;
      min-width: 6% !important;
      max-width: 6% !important;
    }
    
    .ant-table-row-expand-icon-cell {
      width: 6% !important;
      min-width: 6% !important;
      max-width: 6% !important;
    }
  }

  table {
    border-spacing: 0;
    
    colgroup col {
      width: 0 !important;
      min-width: 0 !important;
    }
    
    tbody {
      width:100%
      tr {
        display: flex !important;
        td {
          border: 11px solid rgba(0, 0, 0, 0.06) !important;
          border-style: solid none !important;
          position: relative;
          height: 60px !important; /* Fixed height for consistent borders */
          vertical-align: middle !important;
        }
        td:first-child {
          border-left-style: solid !important;
          border-top-left-radius: 15px !important;
          border-bottom-left-radius: 15px !important;
          text-align: center;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
        }
        td:last-child {
          border-right-style: solid !important;
          border-bottom-right-radius: 15px !important;
          border-top-right-radius: 15px !important;
          border-bottom: 11px solid rgba(0, 0, 0, 0.06) !important;
        }
        
        /* Normalize all content cells */
        td:not(:first-child):not(:last-child) {
          display: flex !important;
          align-items: center !important;
          padding: 12px 16px !important;
        }
        
        /* Fix for circular buttons and drag handles */
        .ant-radio-wrapper,
        .ant-checkbox-wrapper {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100%;
          margin: 0;
        }
        
        /* Normalize expand icons */
        .anticon-right-circle,
        .anticon-down-circle {
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          height: 24px !important;
          width: 24px !important;
        }
        
        /* Normalize drag handle */
        .anticon-menu {
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          height: 24px !important;
          width: 24px !important;
        }
      }
    }
  }
`;
